import { FC } from 'react';

export const SaleBlotterSkeleton: FC = () => {
  return (
    <div>
      <h2 className="mb-4 font-heebo text-lg font-medium text-white">Sale Blotter</h2>
      <div className="flex overflow-x-auto xl:overflow-x-visible">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="flex-1 flex-shrink-0 cursor-pointer rounded border border-transparent-0 border-r-slate-500 bg-background-canvas p-3 text-white transition-[background-color,border-color,box-shadow] duration-150 last:border-r-transparent-0 hover:border-accent-default hover:bg-slate-800 hover:ring-1 hover:ring-accent-default"
          >
            <div className="mb-2 h-4 w-32 max-w-[130px] animate-pulse break-words rounded bg-purple-300 font-medium text-purple-300 brightness-50"></div>
            <div className="mb-2 h-4 w-16 animate-pulse rounded bg-slate-700"></div>
            <div className="flex max-w-48 justify-between font-bold">
              <div className="mb-2 h-4 w-20 animate-pulse rounded bg-slate-700"></div>
              <div className="mb-2 h-4 w-10 animate-pulse rounded bg-slate-700"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
